var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button-group',[_c('el-button',{on:{"click":function($event){return _vm.computeTime(7)}}},[_vm._v("最近一周")]),_c('el-button',{on:{"click":function($event){return _vm.computeTime(30)}}},[_vm._v("最近一个月")]),_c('el-button',{on:{"click":function($event){return _vm.computeTime(90)}}},[_vm._v("最近三个月")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }